import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostHog } from 'posthog-js/react';

import { CSVLink } from 'react-csv';
import { API_BASE_URL } from '../../config';
import axios from 'axios';
import makeStyles from '@mui/styles/makeStyles';

import GridItem from '@/components/Grid/GridItem';
import GridContainer from '@/components/Grid/GridContainer';

import Card from '@/components/Card/Card';

import Button from '@/components/CustomButtons/Button';
import DatePicker from 'react-datepicker';

import styles from '@/assets/jss/material-dashboard-react/views/dashboardStyle';
import search from '../../assets/img/search.svg';
import moment from 'moment';
import { ErrorOutline, Replay, HowToReg, OpenInNew } from '@mui/icons-material';
import DoughnutChart from './DoughnutChart';
import { BusinessUnitsApi } from '@/api/clients/business-units/business-units.api';
import { FacilitiesApi } from '@/api/clients/facilities/facilities.api';
import BarChart from './BarChart';
import { Link } from 'react-router-dom';
import DashboardInfoCard from './DashboardInfoCard';
import { checkOrganizationFeatures, ORGANIZATION_FEATURES } from '@/utility';
import TangoGiftCardBalance from '@/components/TangoGiftCardBalance/TangoGiftCardBalance';

const useStyles = makeStyles(styles);

export default function Facilitydashboard() {
  const { t } = useTranslation();
  const posthog = usePostHog();
  const isCustomPaymentTypesEnabled = posthog?.isFeatureEnabled(
    'new-custom-payment-types-workflow',
  );
  const [businessUnits, setBusinessUnits] = useState([]);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState('');
  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState('');
  useEffect(() => {
    const fetchData = async () => {
      setBusinessUnits(await BusinessUnitsApi.getBusinessUnitsForForm());
      setFacilities(await FacilitiesApi.getFacilitiesForForms());
    };
    fetchData();
  }, []);

  const classes = useStyles();

  const [startdate, setStartdate] = useState(
    moment().subtract(1, 'month').toDate(),
  );
  const [enddate, setEnddate] = useState(new Date());

  const [radiovalue, setRadiovalue] = useState('transaction');

  const [refundMethodsTransaction, setRefundMethodsTransaction] = useState([]);
  const [pieChartData, setPieChartData] = useState({
    claimed: 0,
    unclaimed: 0,
    escheated: 0,
    requested: 0,
  });

  const [moovAccounts, setMoovAccounts] = useState([]);
  const [exceptionsCount, setExceptionsCount] = useState(0);
  const [achReturned, setAchReturned] = useState(0);
  const [awaitingApproval, setAwaitingApproval] = useState(0);

  const handleClicks = (event) => {
    setRadiovalue(event.target.value);
  };
  /************************** Change start date *********************/
  const changeDate = (event) => {
    setStartdate(event);
  };

  /**************************  Change end date **************************/
  const changeEndDate = (event) => {
    setEnddate(event);
  };

  // Search function used to make API calls to backend

  const searchReport = () => {
    if (startdate > enddate) {
      alert(t('dashboard.admin.messages.dateValidation'));
    } else {
      // sending the formdata with ID to backend and recieving respective data.
      axios
        .post(API_BASE_URL + '/search_refund_report', {
          start_date: startdate,
          end_date: enddate,
          business_unit_id: selectedBusinessUnit,
          facility_id: selectedFacility,
        })
        .then((res) => {
          setRefundMethodsTransaction(res.data.countAndTotalPerMethod);
          setPieChartData(res.data.totals);
          setExceptionsCount(res.data.exceptionsCount ?? 0);
          setAchReturned(res.data.achReturned ?? 0);
          setAwaitingApproval(res.data.awaitingApproval ?? 0);
        })
        .catch((err) => {
          console.log('request error ' + err.message);
        });
    }
  };

  useEffect(() => {
    searchReport();
  }, []);
  const headers1 = [
    { label: t('dashboard.admin.csv.refundTypeHeader'), key: 'method' },
    { label: t('dashboard.admin.csv.transactionCountHeader'), key: 'count' },
    { label: t('dashboard.admin.csv.refundedAmountHeader'), key: 'amount' },
  ];
  const headers3 = [
    { label: t('dashboard.admin.csv.refundClaimedHeader'), key: 'claimed' },
    { label: t('dashboard.admin.csv.refundUnclaimedHeader'), key: 'unclaimed' },
    { label: t('dashboard.admin.csv.refundEscheatedHeader'), key: 'escheated' },
  ];

  // input data for CSV file
  const csvReport1 = {
    data: refundMethodsTransaction,
    headers: headers1,
    filename: 'Distribution_of_refund_methods.csv',
  };
  const csvReport3 = {
    data: [pieChartData],
    headers: headers3,
    filename: 'Refund_Claim_VS_Refund_UnClaim.csv',
  };
  const getTOosToken = async (accountId) => {
    try {
      const response = await axios.get('https://api.moov.io/tos-token');

      await axios.post(API_BASE_URL + '/acceptToc', {
        token: response.data.token,
        accountId: accountId,
      });

      setMoovAccounts((prevAccounts) =>
        prevAccounts.map((account) =>
          account.account_id === accountId
            ? {
                ...account,
                is_terms_and_condition: true,
              }
            : account,
        ),
      );
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        API_BASE_URL + '/isMoovTermsAndConditionsAccepted',
      );
      setMoovAccounts(response.data.moovAccounts || []);
    };
    fetchData();
  }, []);

  return (
    <>
      {moovAccounts
        .filter((account) => account?.is_terms_and_condition === false)
        .map((account, index) => (
          <div
            key={account.id}
            style={{
              width: '500px',
              background: '#fff',
              padding: '10px 30px',
              boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;',
              display: 'flex',
              gap: '20px',
              position: 'fixed',
              top: `${60 + index * 120}px`,
              right: '20px',
              color: '#000',
              zIndex: 10,
              fontSize: '12px',
              borderRadius: '5px',
            }}>
            <p>
              {t('dashboard.facility.moov.termsAcceptance')} for account &quot;
              {account.account_name}&quot;{' '}
              <b>
                <a
                  target='_blank'
                  style={{ cursor: 'pointer' }}
                  href='https://moov.io/legal/platform-agreement/'
                  rel='noreferrer'>
                  {t('dashboard.facility.moov.termsOfService')}
                </a>
              </b>
            </p>
            <Button
              variant='contained'
              color='primary'
              onClick={() => getTOosToken(account.account_id)}>
              {t('dashboard.facility.moov.agreeButton')}
            </Button>
          </div>
        ))}
      <div className='facilityDashboard'>
        <GridContainer>
          <TangoGiftCardBalance />

          <GridItem xs={12} sm={6} md={3}>
            <DashboardInfoCard
              color='danger'
              icon={<ErrorOutline style={{ color: '#fff' }} />}
              category={t('dashboard.facility.cards.itemsNeedingAttention')}
              value={<small>{exceptionsCount}</small>}
              footer={
                <div className={classes.stats}>
                  <Link
                    to='/facility/exceptions'
                    style={{
                      color: 'inherit',
                      textDecoration: 'underline',
                      fontSize: '13px',
                      cursor: 'pointer',
                      display: 'inline-flex',
                      gap: '4px',
                    }}>
                    {t('dashboard.facility.actions.viewExceptions')}
                    <OpenInNew
                      fontSize='small'
                      style={{ verticalAlign: 'middle' }}
                    />
                  </Link>
                </div>
              }
            />
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <DashboardInfoCard
              color='info'
              icon={<Replay style={{ color: '#fff' }} />}
              category={t('dashboard.facility.cards.returnedAch')}
              value={<small>{achReturned}</small>}
              footer={
                <div className={classes.stats}>
                  <Link
                    to='/facility/facility-transaction?quickFilter=All+Returned'
                    style={{
                      color: 'inherit',
                      textDecoration: 'underline',
                      fontSize: '13px',
                      cursor: 'pointer',
                      display: 'inline-flex',
                      gap: '4px',
                    }}>
                    {t('dashboard.facility.actions.visitTransactions')}
                    <OpenInNew
                      fontSize='small'
                      style={{ verticalAlign: 'middle' }}
                    />
                  </Link>
                </div>
              }
            />
          </GridItem>
          {checkOrganizationFeatures(
            ORGANIZATION_FEATURES.showApprovalsPage,
          ) && (
            <GridItem xs={12} sm={6} md={3}>
              <DashboardInfoCard
                color='success'
                icon={<HowToReg style={{ color: '#fff' }} />}
                category={t('dashboard.facility.cards.approvalsNeeded')}
                value={<small>{awaitingApproval}</small>}
                footer={
                  <div className={classes.stats}>
                    <Link
                      to='/facility/approvals'
                      style={{
                        color: 'inherit',
                        textDecoration: 'underline',
                        fontSize: '13px',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        gap: '4px',
                      }}>
                      <span>
                        {t('dashboard.facility.actions.viewApprovals')}
                      </span>
                      <OpenInNew
                        fontSize='small'
                        style={{ verticalAlign: 'middle' }}
                      />
                    </Link>
                  </div>
                }
              />
            </GridItem>
          )}
        </GridContainer>
        <GridContainer className='filterCardContainer'>
          <GridItem xs={12} sm={12} md={12} lg={9}>
            <Card className='filterCard'>
              <p className='filter_txt'>
                {t('dashboard.facility.filters.filterBy')}
              </p>
              <div>
                {' '}
                <div className='t-header search-facility'>
                  <div className='t-header-left'>
                    {t('dashboard.admin.dateFilters.fromLabel')}&nbsp;&nbsp;
                    <DatePicker
                      className='full-width-elem-date-picker'
                      id='dt'
                      selected={startdate}
                      onChange={changeDate}
                    />
                  </div>
                  <div className='t-header-left'>
                    {t('dashboard.admin.dateFilters.toLabel')}&nbsp;&nbsp;
                    <DatePicker
                      className='full-width-elem-date-picker'
                      id='dt'
                      selected={enddate}
                      onChange={changeEndDate}
                    />
                  </div>

                  <div className='t-header-right'>
                    <div>
                      <select
                        id='facility'
                        className='full-width-elem'
                        onChange={(e) => setSelectedFacility(e.target.value)}>
                        <option value={''}>
                          {t(
                            'dashboard.facility.filters.facilitiesPlaceholder',
                          )}
                        </option>
                        {facilities.map((facility) => (
                          <option value={facility.id} key={facility.id}>
                            {facility.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {checkOrganizationFeatures(
                    ORGANIZATION_FEATURES.showBusinessUnitsPage,
                  ) && (
                    <div className='t-header-right'>
                      <div>
                        <select
                          id='status'
                          className='full-width-elem'
                          onChange={(e) =>
                            setSelectedBusinessUnit(e.target.value)
                          }>
                          <option value={''}>
                            {t(
                              'dashboard.facility.filters.businessUnitPlaceholder',
                            )}
                          </option>
                          {businessUnits.map((obj) => (
                            <option value={obj.id} key={obj.id}>
                              {obj.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                  <div className='search_t_head'>
                    <Button
                      type='button'
                      color='primary'
                      onClick={searchReport}>
                      <img src={search} className='search_ico' />
                    </Button>
                  </div>
                </div>
              </div>
            </Card>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={6}>
            <Card className='dashboardCard'>
              <h3 className='chart_heads'>
                {t('dashboard.admin.charts.distributionTitle')}
              </h3>
              <div style={{ width: '100%', height: '80%', paddingTop: '10%' }}>
                <BarChart
                  showCount={radiovalue === 'transaction'}
                  data={refundMethodsTransaction}
                  role={'facility'}
                  isCustomPaymentTypesEnabled={isCustomPaymentTypesEnabled}
                />
              </div>

              <div className='dashboardRadio'>
                <div style={{ fontSize: '12px' }}>
                  <input
                    type='radio'
                    value='transaction'
                    onChange={handleClicks}
                    checked={radiovalue == 'transaction'}
                    name='radiocheck'
                  />{' '}
                  {t('dashboard.admin.radio.numberOfTransactions')}
                </div>{' '}
                <div style={{ fontSize: '12px' }}>
                  <input
                    type='radio'
                    value='refund'
                    checked={radiovalue == 'refund'}
                    onChange={handleClicks}
                    name='radiocheck'
                  />{' '}
                  {t('dashboard.admin.radio.amountByRefund')}
                </div>
              </div>
              <CSVLink
                {...csvReport1}
                style={{ cursor: 'pointer' }}
                className='dashboardBtn'>
                {t('dashboard.admin.charts.downloadReport')}
              </CSVLink>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6}>
            <Card className='dashboardCard'>
              <h3 className='chart_heads'>
                {t('dashboard.admin.charts.unclaimedVsRequestedVsClaimed')}
              </h3>

              <div
                style={{
                  width: '100%',
                  position: 'relative',
                  height: '80%',
                  paddingTop: '10%',
                }}>
                <DoughnutChart
                  claimed={pieChartData.claimed}
                  unclaimed={pieChartData.unclaimed}
                  requested={pieChartData.requested}
                />
              </div>
              <CSVLink
                {...csvReport3}
                style={{ cursor: 'pointer' }}
                className='dashboardBtn'>
                {t('dashboard.admin.charts.downloadReport')}
              </CSVLink>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </>
  );
}
